const resolveCurrentColumn = (isEdit, task, activity, columns, roles) => {
  const {
    KANBAN_COLUMN_ROLE_PENDING,
    KANBAN_COLUMN_ROLE_FINALIZED,
    KANBAN_COLUMN_ROLE_IN_PROGRESS,
  } = roles

  if (!isEdit) return null

  if (task?.targetCompanyId) {
    const organizationRole = (task.kanbanColumn || activity?.kanbanColumn)?.role
    const mappedRole =
      organizationRole === KANBAN_COLUMN_ROLE_PENDING
        ? KANBAN_COLUMN_ROLE_PENDING
        : organizationRole === KANBAN_COLUMN_ROLE_FINALIZED
        ? KANBAN_COLUMN_ROLE_FINALIZED
        : KANBAN_COLUMN_ROLE_IN_PROGRESS
    return columns.find((column) => column.role === mappedRole) || null
  }

  return (
    columns.find((column) => column.id === activity?.kanbanColumnId) ||
    activity?.kanbanColumn ||
    null
  )
}

export default resolveCurrentColumn
